import AnalyticsApi from 'utils/AnalyticsApi';

export default class GoogleAnalytics extends AnalyticsApi {
  constructor(options) {
    super("Google Analytics", "google", options);
  }

  isSetUp() {
    return !!window.ga;
  }

  sendTracking(hitType , params) {
    window.ga('send', {hitType, ...params});
  }
}



// WEBPACK FOOTER //
// ./utils/GoogleAnalytics.js